import React from "react";
import { useDispatch } from "react-redux";
import {
  addProject,
  removeProject,
} from "../../features/projects/projectsSlice";
// {
//     "id": 1,
//     "projectName": "Scoreboard",
//     "colorClass": "color-scoreboard"
// }
const ProjectItem = ({ project = {} }) => {
  const dispatch = useDispatch();
  const [checked, setChecked] = React.useState(true);
  const { projectName, colorClass } = project;
  const handleChange = (e) => {
    setChecked(e.target.checked);
    if (!checked) {
      dispatch(addProject(projectName));
    } else {
      dispatch(removeProject(projectName));
    }
  };
  return (
    <div className="checkbox-container">
      <input
        type="checkbox"
        className={colorClass}
        checked={checked}
        value={projectName}
        onChange={handleChange}
      />
      <p className="label">{projectName}</p>
    </div>
  );
};

export default ProjectItem;
